import styled from 'styled-components'
// components
import { Link as RouterLink } from 'react-router'
// theme
import { colors } from 'themes/index'

export const Link = styled(RouterLink)`
  text-decoration: none;
`

export const LinkContent = styled.span`
  font-weight: 500;
  color: ${colors.blue300};
  font-size: 15px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`
